import * as React                       from 'react';

import { Typography                   } from 'src/components/common/typography';
import { Button                       } from 'src/components/common/button';
import { LabeledContent               } from 'src/components/common/labeled-content';

import { Container,
         Block,
         Hr,
         ComplaintDefectItemVariants,
         complaintdefectitem_variants } from 'src/components/features/inspection/view/complaint-defect-item/ui';

import { ComplaintType                } from 'src/services/api/types/inspection';
import * as types                       from 'src/services/api/types';

import { storeApi,
         useAppSelector,
         useAppDispatch               } from 'src/store';



type Props = {
  variant: ComplaintDefectItemVariants;
  defect: types.inspection.Defect;
  isLast: boolean;
}
export const ComplaintDefectItem: React.FC<Props> = ({
  variant,
  defect,
  isLast,
}) => {
  const lookAndFeel = complaintdefectitem_variants.get(variant)!;
  const dispatch = useAppDispatch();

  const defectTitle = defect.defectTitle;
  const defectGuid = defect.guid;

  const qmetIds = useAppSelector((store) => storeApi.inspection.view.selectors.selectDefectQmetIds(store, defectGuid));
  const pieceIds = useAppSelector((store) => storeApi.inspection.view.selectors.selectDefectPieceIds(store, defectGuid));
  const groupAttIds = useAppSelector((store) => storeApi.inspection.view.selectors.selectDefectGroupAttIds(store, defectGuid));
  const mechanicalEngineeringParts = useAppSelector((store) => storeApi.inspection.view.selectors.selectDefectKolpinoMechanicalEngineeringParts(store, defectGuid));
  const processedSheets = useAppSelector((store) => storeApi.inspection.view.selectors.selectDefectKolpinoProcessedSheets(store, defectGuid));
  const unprocessedSheets = useAppSelector((store) => storeApi.inspection.view.selectors.selectDefectKolpinoUnprocessedSheets(store, defectGuid));

  const complaintType = defect.complaint?.typeComplaint ?? null

  const onActionHandler = () => {
    if (defect.complaint !== null)
    {
      dispatch(storeApi.inspection.view.actions.changeComplaintSelected({
        complaint: defect.complaint,
        complaintDefectGuid: defectGuid,
      }));
    }
    else
    {
      // todo - показать алерт, что отсутствуют требования/рекламация
    }
  }

  return (
    <Container lookAndFeel = { lookAndFeel }>
      <Block lookAndFeel = { lookAndFeel }>
        {defectTitle !== null && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Дефект'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ defectTitle }</Typography>
          </LabeledContent>
        )}
        {qmetIds !== '' && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Идентификационный №'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ qmetIds }</Typography>
          </LabeledContent>
        )}
        {pieceIds !== '' && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Номер рулона / листа / трубы'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ pieceIds }</Typography>
          </LabeledContent>
        )}
        {groupAttIds !== '' && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Партия атт / сертификат'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ groupAttIds }</Typography>
          </LabeledContent>
        )}
        {mechanicalEngineeringParts !== '' && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Лист / сертификат'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ mechanicalEngineeringParts }</Typography>
          </LabeledContent>
        )}
        {processedSheets !== '' && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Лист / сертификат'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ processedSheets }</Typography>
          </LabeledContent>
        )}
        {unprocessedSheets !== '' && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Плавка / партия / сертификат'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ unprocessedSheets }</Typography>
          </LabeledContent>
        )}
        {complaintType !== null && complaintType !== ComplaintType.NONE && (
          <LabeledContent variant = { lookAndFeel.blockLabeledVariant } label = 'Рекламация'>
            <Typography variant = { lookAndFeel.blockItemTypography }>{ complaintType === ComplaintType.COMPLAINT ? 'Рекламация' : 'Замечание' }</Typography>
          </LabeledContent>
        )}
      </Block>
      {complaintType !== null && complaintType !== ComplaintType.NONE && (
        <Button
          variant = { lookAndFeel.actionButtonVariant }
          label = { 'Просмотреть требование' }
          onTap = { onActionHandler }
        />
      )}
      {!isLast && (
        <Hr lookAndFeel = { lookAndFeel } />
      )}
    </Container>
  );
};
